import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.ai-assistant': {
         aiAssistantButton: {
            label: 'Asystent AI',
         },
         consentGate: {
            cancel: 'Anuluj',
            confirm: 'Potwierdź zgodę',
            message: 'Przed rozpoczęciem nagrywania potwierdź, że pacjent wyraził zgodę na nagrywanie rozmowy.',
            title: 'Zgoda na nagrywanie',
         },
         continuousMode: {
            chatInfo:
               'Prezentowana transkrypcja pełni jedynie funkcję poglądową i nie świadczy o finalnej jakości generowanej treści',
            consentRequired: 'Nagrywanie wymaga zgody pacjenta',
            errorGeneric: 'Wystąpił błąd podczas nagrywania.',
            errorSessionTimeout: 'Sesja nagrywania zakończyła się z powodu osiągnięcia limitu czasu (4 godziny).',
            listeningStatus: 'Słucham rozmowy...',
            pause: 'Wstrzymaj',
            processing: 'Przetwarzanie...',
            proposalsReady: 'Propozycje treści są gotowe',
            recordingActive: 'Nagrywanie rozmowy aktywne',
            recordingPaused: 'Nagrywanie wstrzymane',
            resume: 'Wznów',
            speaker1: 'Mówca 1',
            speaker2: 'Mówca 2',
            start: 'Rozpocznij nagrywanie rozmowy',
            stop: 'Zatrzymaj nagrywanie',
         },
         dictationMode: {
            listeningPlaceholder: 'Słucham...',
            redactEmptyWarning: 'Brak danych do redagowania',
            redactSourceTranscript: 'Transkrypcję',
            redactSourceVisitField: 'Pole z wizyty',
            start: 'Nagrywaj',
            stop: 'Zatrzymaj',
         },
         faults: {
            bedrockTimeout: 'Redakcja trwała zbyt długo. Spróbuj ponownie.',
            bedrockUnavailable: 'Usługa redakcji jest chwilowo niedostępna.',
            buyTokens: 'Dokup tokeny',
            featureNotEnabled: 'Funkcja transkrypcji nie jest włączona dla Twojego konta.',
            microphoneAccessDenied: 'Brak dostępu do mikrofonu. Sprawdź uprawnienia przeglądarki.',
            microphoneSilenceDisconnect: 'Transkrypcja przerwana z powodu braku danych z mikrofonu',
            quotaExceeded: 'Wyczerpano pakiet minut transkrypcji.',
            redactionTokensQuotaExceeded: 'Brakuje tokenów, aby redagować tekst. <link /> w Ustawieniach podmiotu.',
            tokensQuotaCritical:
               'Pozostało tylko 10% tokenów w tym miesiącu. Nagrywanie wizyty może zostać przerwane. <link /> w Ustawieniach podmiotu.',
            tokensQuotaExceeded: 'Brakuje tokenów, aby uruchomić Asystenta wizyty. <link /> w Ustawieniach podmiotu.',
            tokensQuotaLow: 'Pozostało tylko 25% tokenów w tym miesiącu. <link /> w Ustawieniach podmiotu.',
            transcriptionCredentialsUnavailable: 'Usługa autoryzacji jest chwilowo niedostępna. Spróbuj ponownie.',
         },
         fieldProposalReview: {
            accept: 'Akceptuj',
            acceptAll: 'Akceptuj wszystkie',
            accepted: 'Zaakceptowano',
            assignTo: 'Przydziel do',
            close: 'Zamknij',
            fieldExamination: 'Badanie przedmiotowe',
            fieldInterview: 'Wywiad',
            fieldRecommendations: 'Zalecenia',
            fieldUnassigned: 'Nieprzypisane',
            limitExceeded: 'Nie można zaakceptować — przekroczono limit 10 000 znaków',
            reject: 'Odrzuć',
            rejected: 'Odrzucono',
            title: 'Propozycje treści',
            verificationRequired: 'Wymaga weryfikacji przez lekarza',
         },
         fieldSelector: {
            legend: 'Pole docelowe',
         },
         mainMenuTileItem: {
            consentModal: {
               cancel: 'Anuluj',
               confirm: 'Potwierdź zgodę i nagraj',
               message: 'Przed rozpoczęciem nagrania potwierdź, że pacjent wyraził zgodę na nagrywanie rozmowy.',
               title: 'Zgoda pacjenta na nagrywanie',
            },
            creatingNote: 'Tworzenie notatki',
            elapsedTime: '{{minutes}}:{{seconds}}',
            emptyTranscriptWarning: 'Nagranie nie zawiera wypowiedzi - notatka nie została wygenerowana.',
            generateNote: 'Generuj notatkę',
            mobileRecordingInProgress: 'Trwa nagrywanie na urządzeniu...',
            recordAgain: 'Nagraj od nowa',
            recordAgainModal: {
               message:
                  'Czy na pewno chcesz nagrać notatkę od nowa? Spowoduje to utratę obecnej notatki z wizyty. ' +
                  'Aby zachować dane wprowadź informacje z notatki do odpowiednich pól w wizycie.',
               no: 'Nie',
               title: 'Nagranie od nowa',
               yes: 'Tak',
            },
            resumeRecording: 'Wznów nagranie',
            run: 'Uruchom',
            showNote: 'Pokaż notatkę',
            soundSource: {
               continueOnDevice: 'Kontynuuj na urządzeniu.',
               label: 'Wybierz źródło dźwięku, którego chcesz użyć do nagrywania',
               microphonePlaceholder: 'Domyślny mikrofon',
               phoneConnectInstruction:
                  'Aparatem zeskanuj kod QR, aby podłączyć urządzenie i korzystać z mikrofonu wbudowanego w telefon.',
               phoneDescription:
                  'Możesz użyć zewnętrznego urządzenia, aby rejestrować dźwięk podczas wizyty. Przed rozpoczęciem nagrywania wyświetlimy kod QR, za pomocą którego się połączysz.',
               qrCodeGenerateFailed: 'Nie udało się wygenerować kodu QR',
               status: 'Status',
               statusConnected: 'Połączono',
               statusWaitingForDevice: 'Oczekiwanie na urządzenie',
               unnamedMicrophone: 'Mikrofon bez nazwy',
            },
            soundSourceMap: {
               COMPUTER: 'Mikrofon komputera',
               PHONE: 'Mikrofon telefonu lub tabletu',
            },
            summaryModal: {
               accept: 'Akceptuj i przenieś do wizyty',
               close: 'Zamknij',
               fieldExamination: 'Badania przedmiotowe',
               fieldInterview: 'Wywiad',
               fieldRecommendations: 'Zalecenia',
               title: 'Notatka wygenerowana na podstawie nagrania ({{minutes}} min {{seconds}} sek)',
               transferToVisit: 'Przenieś do wizyty',
               unassignedInfo: 'Nie zostaną przeniesione do wizyty, ale pozostaną dostępne z poziomu podglądu notatki.',
               unassignedTitle: 'Notatki nieprzypisane',
               verifyContentInfo: 'Poniższe treści wymagają weryfikacji.',
            },
            title: 'Asystent wizyty',
         },
         modeSelector: {
            continuous: 'Podsumowanie wizyty',
            dictation: 'Dyktowanie',
            label: 'Tryb transkrypcji',
         },
         panel: {
            close: 'Zamknij panel transkrypcji',
            fieldExamination: 'Badanie przedmiotowe',
            fieldInterview: 'Wywiad',
            fieldRecommendations: 'Zalecenia',
            processing: 'Łączenie...',
            recordButtonStart: 'Rozpocznij nagrywanie',
            recordButtonStop: 'Zatrzymaj nagrywanie',
            redactButton: 'Redaguj z AI',
            redactButtonLoading: 'Redagowanie tekstu...',
            redactionAccept: 'Akceptuj',
            redactionOriginalTitle: 'Oryginał',
            redactionProposalTitle: 'Propozycja redakcji',
            redactionReject: 'Odrzuć',
            redactionRetry: 'Ponów redakcję',
            summaryButton: 'Podsumuj rozmowę',
            summaryButtonLoading: 'Generowanie podsumowania...',
            title: 'Transkrypcja',
         },
         processingIndicator: {
            fieldsLocked: 'Edycja pól jest zablokowana podczas przetwarzania',
            message: 'Konstrukcja odpowiedzi...',
         },
         quota: {
            exhausted: 'Pakiet minut transkrypcji wyczerpany',
            nearLimit: 'Zbliżasz się do limitu minut transkrypcji',
            remaining: 'Pozostało {{minutes}} min',
         },
         settingsPanel: {
            buyTokens: 'Dokup tokeny',
            currentPlan: 'Obecny plan',
            description:
               'Tokeny są zużywane podczas korzystania z funkcji AI, są współdzielone przez wszystkich użytkowników i odnawiają się z początkiem miesiąca.',
            disableAiAssistantWarning:
               'Wyłączenie Asystenta wizyty i funkcji AI nie powoduje anulowania subskrypcji lub zmiany planu.',
            enableAiAssistant: 'Włącz Asystenta wizyty i funkcje AI',
            enableAiAssistantDescription: 'Umożliwia nagrywanie i podsumowywanie wizyt oraz redagowanie tekstu.',
            header: 'Plan i wykorzystanie tokenów',
            recordingInProgressFault:
               'Nie można zmienić ustawienia, ponieważ trwa nagrywanie wizyty. Zakończ nagrywanie i spróbuj ponownie.',
            saveOff: 'Wyłączono Asystenta wizyty i funkcje AI.',
            saveOn: 'Włączono Asystenta wizyty i funkcje AI.',
            tabName: 'Asystent wizyty',
            tokensUsage: 'Wykorzystano <bold>{{usage}}</bold> z <bold>{{limit}} tokenów</bold>',
            tokensUsageExceeded: 'Wykorzystano <bold>{{usage}}</bold> z <bold>{{limit}}</bold> ({{balance}})',
            variantMap: {
               ADDITIONAL_500: 'Dodatkowy pakiet +500',
               AI_ASSISTANT_120: 'AI Asystent 120',
               AI_ASSISTANT_1500: 'AI Asystent 1500',
               AI_ASSISTANT_2500: 'AI Asystent 2500',
               AI_ASSISTANT_600: 'AI Asystent 600',
               STARTER_100: 'Pakiet startowy 100',
            },
         },
         silenceCountdown: {
            message: 'Brak dźwięku. Połączenie zostanie przerwane za {{seconds}} s.',
         },
         voiceVisualizer: {
            active: 'Wizualizator głosu aktywny',
            inactive: 'Wizualizator głosu nieaktywny',
            label: 'Wizualizator głosu',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.ai-assistant');
export const aiAssistantSettingsPanelTranslationKeys = translationKeys.settingsPanel;
